import { useTranslation } from 'react-i18next';

import { useSearchParams } from '@remix-run/react';

import { SubscriberGate } from '~/components/Actions/types';
import type { Publication } from '~/interfaces/publication';
import type { Site } from '~/interfaces/site';
import FreeGatedContent from '~/pages/post/FreeGatedContent';

import { SiteModalSlotContext } from '../DreamBuilder/nodes/context/SiteModalSlotContext';

import { serializeNode } from '../DreamBuilder/nodes/serializeNode';
import PrivateHeader from './PrivateHeader';

interface PrivatePublicationProps {
  publication: Publication;
  site: Site;
}

const PrivatePublication = ({ publication, site }: PrivatePublicationProps) => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  const isLoginModalOpen = searchParams.get('modal') === 'login';

  return (
    <>
      <PrivateHeader publication={publication} />

      {publication.private && (
        <FreeGatedContent
          title={t('gated.private_newsletter.title')}
          message={t('gated.private_newsletter.message')}
          publication={publication}
        />
      )}

      {!publication.private && publication.require_subscriber_approval && (
        <FreeGatedContent
          title={t('gated.require_approval.title')}
          message={t('gated.require_approval.message')}
          publication={publication}
          createActionType={SubscriberGate.NONE}
        />
      )}

      {/* Render login modal when ?modal=login is present */}
      {isLoginModalOpen && site.viewable_site_version?.login_modal && (
        <SiteModalSlotContext.Provider value>
          {serializeNode(site.viewable_site_version.login_modal, '!min-h-0')}
        </SiteModalSlotContext.Provider>
      )}
    </>
  );
};

export default PrivatePublication;
